import { Reveal } from "../components/Reveal";
import { PortfolioCard } from "../components/PortfolioCard";
import { PROJECTS } from "../data/portfolio";

export default function PortfolioPage() {
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="text-center max-w-2xl mx-auto mb-12">
              <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">PORTFOLIO</p>
              <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#F7FAFF]">
                Our <span className="text-gradient">Work.</span>
              </h1>
              <p className="mt-5 text-base md:text-lg text-[#AEBFD8] leading-relaxed">
                A selection of placeholder projects in our signature glass style. This page will be updated with real
                client work over time.
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {PROJECTS.map((p, i) => (
                <Reveal key={p.slug} delay={i * 0.08}><PortfolioCard project={p} /></Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
